export const VIDEO_EVENT = 'VIDEO_EVENT';
export const SHOW_VIDEO = 'SHOW_VIDEO';

/**
 * Action to notify that video has been started.
 */
export function videoStarted(watchID) {
    return { type: VIDEO_EVENT, name: 'startVideo', watchID: watchID };
}

/**
 * Action to notify that a video has finished.
 */
export function videoEnded(watchID) {
    return { type: VIDEO_EVENT, name: 'endVideo', watchID: watchID };
}

/**
 * Action to notify that a video has been played.
 */
export function videoPlayed(watchID) {
    return {
        type: VIDEO_EVENT,
        name: 'controlVideo',
        action: 'resume',
        watchID: watchID,
    };
}

/**
 * Action to notify that a video has been paused.
 */
export function videoPaused(watchID) {
    return {
        type: VIDEO_EVENT,
        name: 'controlVideo',
        action: 'pause',
        watchID: watchID,
    };
}

/**
 * Show a video in a video alert
 * @param videoId the id of the video to show
 * @param skillId the id of the skill the video is being shown for
 * @param triggeringView viewId of the view the video is being opened from. When
 * the video is opened we send a Google Analytics page event to show the user
 * has moved to the video, and when it is closed we send a page event back to
 * this view again
 * @param skipToFinalFrame whether to move the video to the final frame when it
 * loads (used in tethering, where the final frame image is not available).
 * @param corsSafe whether we send our credentials over any CORS request when
 * loading the video.
 */
export function showVideo(
    videoId,
    skillId,
    activityIndex,
    triggeringView,
    skipToFinalFrame = false,
    corsSafe = false,
    autoPlay = false,
) {
    return {
        type: SHOW_VIDEO,
        videoId,
        skillId,
        activityIndex,
        triggeringView,
        skipToFinalFrame,
        corsSafe,
        autoPlay,
    };
}
